import React from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-body font-bold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold';
  const variants = {
    primary: 'bg-gold hover:bg-gold-dark text-white shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    secondary: 'bg-olive hover:bg-olive-light text-white shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    outline: 'border-2 border-gold text-gold hover:bg-gold hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-303">
      {children}
    </button>;
}